import { FeatureFlagGuard } from '@platform/client/feature-flags';
import type { FeatureConfig } from '@platform/client/features';

import i18n from './locales/i18n';

export default {
  routes: [
    {
      path: 'account',
      children: [
        {
          path: 'onboarding',
          element: <FeatureFlagGuard featureFlag="NEW_ONBOARDING_EXPERIENCE" />,
          children: [
            {
              index: true,
              lazy: () => import('./onboarding.page'),
            },
          ],
        },
      ],
    },
  ],
  navigation: ({ featureFlags, organization }) => {
    const cid = organization?.customerID;
    const cidQueryParam = cid ? `?cid=${cid}` : '';

    return {
      orgProfile: {
        onboarding: featureFlags?.NEW_ONBOARDING_EXPERIENCE
          ? {
              title: i18n.t('onboarding:pageTitle'),
              segment: '/account/onboarding',
            }
          : {
              title: i18n.t('onboarding:pageTitle'),
              externalUrl: `https://portal.arcticwolf.com/onboarding${cidQueryParam}`,
            },
      },
    };
  },
} satisfies FeatureConfig;
